// extracted by mini-css-extract-plugin
module.exports = {"title":"VpbxInfo_title_2-h-1","numbersWrapper":"VpbxInfo_numbersWrapper_Qv1_C","numbers":"VpbxInfo_numbers_1WVib","lineWrap":"VpbxInfo_lineWrap_16Q4O"};